import { Component, Vue, Watch } from "vue-property-decorator";

@Component({})
export class EntityListProvider<T = unknown> extends Vue {
  /**
   * Represents current loading state for data
   * before onSearch -> true
   * after onSearch -> false
   */
  public isLoading = false;

  /**
   * Represents text which will be used in search
   */
  public searchValue = "";

  /**
   * Represents record field that will be used in search
   * Node: this if searchBy is not provided than search by default of all fields should be
   * implemented on backend side else - throw an error with invalid query parameters
   */
  public searchBy = "";

  /**
   * Represents current page for pagination
   */
  public page = 1;

  /**
   * Represents total pages count for pagination
   */
  public total = 0;

  /**
   * Represents queried items
   */

  public items: T[] = [];

  @Watch("page")
  @Watch("searchBy")
  @Watch("searchValue")
  protected async onSearchOptionsChanged(): Promise<void> {
    try {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      const result = await this.onSearch();

      if (result) {
        this.items = result.items;
        this.total = result.total;
      }
    } catch (error) {
      await this.onError();
    } finally {
      this.isLoading = false;
    }
  }

  public reload(): void {
    this.searchBy = "";
    this.page = 1;
    this.onSearchOptionsChanged().catch(() => null);
  }

  public setSearchValue(value: string): void {
    this.searchValue = value;
  }

  public setSearchBy(value: string): void {
    this.searchBy = value;
  }

  public setPage(value: number): void {
    this.page = value;
  }

  public onError(): Promise<void> | void {}

  public onSearch(): Promise<{ items: T[]; total: number } | null> {
    throw new Error("Method onSearch not implemented");
  }
}
